const state = {
    visible: false,
    message: "",
    popAlert: true,
    isOffline: false,
    options: {
        message: "yayaya",
        submessage: null,
        time: null,
        type: null,
    },
    showError: false,
    optionsError: {
        message: null,
        submessage: null,
        type: null,
    },
};

const mutations = {
    error_show: function (state, payload) {
        state.message = payload;
        state.visible = true;
        window.scrollTo(0, 0);
    },

    error_dismiss: function (state) {
        state.message = "";
        state.visible = false;
    },

    showAlert(state, payload) {
        if (!state.isOffline) {
            state.popAlert = true;
            state.options = payload;
        }
    },

    closeAlert(state, payload) {
        state.popAlert = false;
        state.options = payload;
    },

    showError(state, payload) {
        state.showError = true;
        state.optionsError = payload;
    },

    closeError(state) {
        state.showError = false;
    },

    offlineToggle(state, payload) {
        state.isOffline = payload;
        state.popAlert = payload;
        if (payload) {
            state.options = {
                time: -1,
                type: "error",
                message: "Koneksi Terputus",
            };
        }
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/global/stores/error.js